import {css} from '@emotion/css';
import {colours, fonts, spacing} from '../../../../styles/js/variables';

const size = '4rem'; // @todo share this with the field styling

const styles = {
  container: css`
    label: numberField__container;
    display: flex;
  `,

  afterField: css`
    label: numberField__after;
    align-content: center;
    color: ${colours.border.LIGHT_GRAY};
    display: flex;
    flex-direction: column;
    font-size: ${fonts.size.XXL};
    height: ${size};
    justify-content: center;
    margin-left: -${size};
    position: relative;
    top: ${spacing.XXXS};
    width: ${size};
  `,

  afterFieldContent: css`
    label: numberField__after__content;
    display: flex;
    place-content: center;
    flex-direction: row;
  `,
};

export default styles;
